export const CLOSE = 'GEM-ANDROID-APP-CLOSE';
export const INSTALLED = 'GEM-ANDROID-APP-INSTALLED';
